import { borderRadius_5px, css, setColor_25476d, setFlexDFAICJCSB, setFontSize_13px, setFontWeight600, setProps, styled } from "theme";

type Props = {
  isFirst: boolean;
  isLast: boolean;
  isArabic: boolean;
  isCallBack: boolean;
};

const isFirstSet = setProps<Props>(({ isFirst }) => isFirst)(css`
  border-top-right-radius: ${borderRadius_5px};
  border-bottom-right-radius: ${borderRadius_5px};
`);

const isLastSet = setProps<Props>(({ isLast }) => isLast)(css`
  border-top-left-radius: ${borderRadius_5px};
  border-bottom-left-radius: ${borderRadius_5px};
`);

const isArabicAndCallbackLang = setProps<Props>(({ isArabic, isCallBack }) => isArabic && isCallBack)(css`
  flex-direction: row-reverse;
`);

const isArabicLang = setProps<Props>(({ isArabic, isCallBack }) => isArabic && !isCallBack)(css`
  justify-content: flex-end;
`);

export const SHeaderCellContainer = styled.div<Props>`
  height: 30px;
  padding-right: 24px;
  padding-left: 14px;
  text-align: left;

  ${setFlexDFAICJCSB};
  ${setFontSize_13px};
  ${setFontWeight600};
  ${setColor_25476d};
  ${isFirstSet};
  ${isLastSet};
  ${isArabicLang};
  ${isArabicAndCallbackLang};
`;
